"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAutoSdlHelp = void 0;
/**
 * Returns the valid link for each component of a module
 *
 * @param dataModel - AppModel for current module
 * @param componentName - Current component under the module
 * @param helpUrl - Generic url
 * @returns Valid link to microchip docs
 */
var getAutoSdlHelp = function (dataModel, componentName, helpUrl) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var deviceMeta = dataModel.getImportValue("device_meta");
    var deviceName = (_a = deviceMeta === null || deviceMeta === void 0 ? void 0 : deviceMeta.deviceName) !== null && _a !== void 0 ? _a : "";
    var moduleName = (_d = (_c = (_b = dataModel.getHardware()) === null || _b === void 0 ? void 0 : _b.getPeripheral()) === null || _c === void 0 ? void 0 : _c.group) !== null && _d !== void 0 ? _d : "";
    var dosid = (_g = (_f = (_e = dataModel.getHardware()) === null || _e === void 0 ? void 0 : _e.getPeripheral()) === null || _f === void 0 ? void 0 : _f.dosid) !== null && _g !== void 0 ? _g : "";
    var comp = (_j = (_h = dataModel.getComponent(componentName)) === null || _h === void 0 ? void 0 : _h.component) !== null && _j !== void 0 ? _j : "";
    var setting = (_l = (_k = comp === null || comp === void 0 ? void 0 : comp.setting) === null || _k === void 0 ? void 0 : _k.toLowerCase()) !== null && _l !== void 0 ? _l : "";
    var registerName = componentName.toLowerCase().replace(setting, "");
    var registerAlias = (_m = registerName === null || registerName === void 0 ? void 0 : registerName.toUpperCase()) !== null && _m !== void 0 ? _m : "";
    var deviceRegister = (_r = (_q = (_p = (_o = dataModel.getPeripheralDescription()) === null || _o === void 0 ? void 0 : _o.registers) === null || _p === void 0 ? void 0 : _p[registerAlias]) === null || _q === void 0 ? void 0 : _q.name) !== null && _r !== void 0 ? _r : "";
    var register = registerAlias == deviceRegister ? registerAlias : deviceRegister;
    var url = helpUrl
        .replace("${deviceName}", deviceName !== null && deviceName !== void 0 ? deviceName : "")
        .replace("${registerName}", register !== null && register !== void 0 ? register : "")
        .replace("${moduleName}", moduleName !== null && moduleName !== void 0 ? moduleName : "")
        .replace("${dosId}", dosid !== null && dosid !== void 0 ? dosid : "");
    return url;
};
exports.getAutoSdlHelp = getAutoSdlHelp;
//# sourceMappingURL=ContextualHelp.js.map